import React from 'react';

const HeroCard = ({ highlights = [] }) => (
  <section className="hero-card">
    <div className="hero-card__intro">
      <h1 className="hero-card__eyebrow">Fabric Design Guide</h1>
      <p>
        Ready to explore your interconnected digital infrastructure strategy? This interactive guide provides a quick and effective way to craft a customized
        strategy tailored to your organization's unique needs.
      </p>
    </div>
    <div className="hero-card__highlights">
      {highlights.map((item) => (
        <div key={item.title} className="highlight-card">
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </div>
      ))}
    </div>
    <div className="hero-card__note">
      <strong>Note:</strong> This navigator is specifically developed for enterprise organizations. IT service providers, networks or other non-enterprise
      entities may not receive the most relevant insights.
    </div>
  </section>
);

export default HeroCard;
